webpackJsonp([0],{

/***/ 450:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['order'],
  data: function data() {
    return {
      err: '',
      successM: '',
      loading: false,
      headers: [{ text: 'Name', value: 'name', align: 'left' }, { text: 'Quantity', value: 'quantity', align: 'right' }],
      items: []
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])({
    company: 'company',
    goDark: 'goDark'
  })),
  methods: {
    blacklist: function blacklist(type) {
      var _this = this;

      this.loading = true;
      this.$webHelper.post('blacklist/' + this.order.webShopOrderId + '?type=' + type).then(function (res) {
        if (res.status === 200) {
          _this.successM = _this.$lang.success.blacklist;
          _this.loading = false;
          setTimeout(function () {
            _this.successM = '';
          }, 6000);
          return;
        }
        _this.err = res.body.statusText;
        _this.loading = false;
        setTimeout(function () {
          _this.err = '';
        }, 6000);
      }).catch(function (err) {
        _this.err = err.body.statusText;
        _this.loading = false;
        setTimeout(function () {
          _this.err = '';
        }, 6000);
      });
    },
    generateAddress: function generateAddress(lines) {
      return lines.filter(function (line) {
        return !!line;
      }).join(', ');
    },
    formatName: function formatName(contact) {
      return (contact.firstName || '') + ' ' + (contact.lastName || '');
    },
    orderTimeLabel: function orderTimeLabel() {
      return this.$lang.actions[this.order.type];
    },
    selectCartItem: function selectCartItem(index) {
      this.items = this.items.map(function (current, i) {
        var item = current;
        item.selected = i === index && !item.selected;
        return item;
      });
    },
    formatDate: function formatDate(time) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(time).format('YYYY-MM-DD HH:mm');
    }
  },
  created: function created() {
    this.items = this.order.items.map(function (item) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item, { selected: false });
    });
  }
});

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(452);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(448)("567be07c", content, true, {});

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(447)(true);
// imports


// module
exports.push([module.i, "p[data-v-db2b2e20]{font-size:16px;color:#efa546}p span[data-v-db2b2e20]{color:rgba(0,0,0,.75)}.sub-header[data-v-db2b2e20]{-webkit-box-flex:0.2;-ms-flex:0.2 1 auto;flex:0.2 1 auto}thead[data-v-db2b2e20]{background-color:#dcdcdc}table.table thead tr[data-v-db2b2e20]{height:44px}tr.item[data-v-db2b2e20]:nth-of-type(2n){background-color:#f3f3f3}tr.item.is-selected:hover td[data-v-db2b2e20],tr.item.is-selected td[data-v-db2b2e20]{background:hsla(0,0%,86%,.6);font-weight:700}.price[data-v-db2b2e20]{min-width:56px;display:inline-block;margin:0;padding-left:8px;position:relative;text-align:right}.price[data-v-db2b2e20]:before{content:attr(data-currency);position:absolute;left:0}.price.no-min[data-v-db2b2e20]{min-width:1px}.quantity[data-v-db2b2e20]{display:inline-block;width:24px;height:24px;text-align:center}.total[data-v-db2b2e20]{font-size:13px}@media only screen and (max-width:768px){.sub-header[data-v-db2b2e20]{width:100%!important}}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/webshop/modals/OrderDetails.vue"],"names":[],"mappings":"AACA,mBACE,eAAgB,AAChB,aAAe,CAChB,AACD,wBACI,qBAA2B,CAC9B,AACD,6BACE,qBAAsB,AAClB,oBAAqB,AACjB,eAAiB,CAC1B,AACD,uBACE,wBAA0B,CAC3B,AACD,sCACE,WAAa,CACd,AACD,yCACE,wBAA0B,CAC3B,AACD,sFACE,6BAAqC,AACrC,eAAiB,CAClB,AACD,wBACE,eAAgB,AAChB,qBAAsB,AACtB,SAAU,AACV,iBAAkB,AAClB,kBAAmB,AACnB,gBAAkB,CACnB,AACD,+BACI,4BAA6B,AAC7B,kBAAmB,AACnB,MAAQ,CACX,AACD,+BACI,aAAe,CAClB,AACD,2BACE,qBAAsB,AACtB,WAAY,AACZ,YAAa,AACb,iBAAmB,CACpB,AACD,wBACE,cAAgB,CACjB,AACD,yCACA,6BACI,oBAAuB,CAC1B,CACA","file":"OrderDetails.vue","sourcesContent":["\np[data-v-db2b2e20] {\n  font-size: 16px;\n  color: #efa546;\n}\np span[data-v-db2b2e20] {\n    color: rgba(0, 0, 0, 0.75);\n}\n.sub-header[data-v-db2b2e20] {\n  -webkit-box-flex: 0.2;\n      -ms-flex: 0.2 1 auto;\n          flex: 0.2 1 auto;\n}\nthead[data-v-db2b2e20] {\n  background-color: #dcdcdc;\n}\ntable.table thead tr[data-v-db2b2e20] {\n  height: 44px;\n}\ntr.item[data-v-db2b2e20]:nth-of-type(even) {\n  background-color: #f3f3f3;\n}\ntr.item.is-selected td[data-v-db2b2e20], tr.item.is-selected:hover td[data-v-db2b2e20] {\n  background: rgba(220, 220, 220, 0.6);\n  font-weight: 700;\n}\n.price[data-v-db2b2e20] {\n  min-width: 56px;\n  display: inline-block;\n  margin: 0;\n  padding-left: 8px;\n  position: relative;\n  text-align: right;\n}\n.price[data-v-db2b2e20]:before {\n    content: attr(data-currency);\n    position: absolute;\n    left: 0;\n}\n.price.no-min[data-v-db2b2e20] {\n    min-width: 1px;\n}\n.quantity[data-v-db2b2e20] {\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n  text-align: center;\n}\n.total[data-v-db2b2e20] {\n  font-size: 13px;\n}\n@media only screen and (max-width: 768px) {\n.sub-header[data-v-db2b2e20] {\n    width: 100% !important;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 453:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-layout',{staticClass:"px-3 pt-2",attrs:{"row":"","wrap":"","justify-space-between":"","align-center":""}},[(_vm.err)?_c('v-flex',{attrs:{"xs12":"","px-4":""}},[_c('v-alert',{attrs:{"value":true,"type":"error"}},[_vm._v(_vm._s(_vm.err))])],1):_vm._e(),_vm._v(" "),(_vm.successM)?_c('v-flex',{attrs:{"xs12":"","px-4":""}},[_c('v-alert',{attrs:{"value":true,"type":"success"}},[_vm._v(_vm._s(_vm.successM))])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-inline-flex pt-2"},[_c('p',{staticClass:"p-0 m-0"},[_vm._v(_vm._s(_vm.$lang.labels.name)+":\n          "),_c('span',{style:(_vm.goDark ? 'color: white' : '')},[_c('strong',[_vm._v(_vm._s(_vm.formatName(_vm.order.contact)))])])]),_vm._v(" "),(_vm.order.contact.address)?_c('p',{staticClass:"pl-5 py-0 m-0"},[_vm._v(_vm._s(_vm.$lang.labels.address)+":\n          "),_c('span',{style:(_vm.goDark ? 'color: white' : '')},[_c('strong',[_vm._v(_vm._s(_vm.generateAddress([
            _vm.order.contact.address.line1,
            _vm.order.contact.address.line2,
            _vm.order.contact.address.line3,
            _vm.order.contact.address.line4 ]))+", "+_vm._s(_vm.order.contact.address.locality ? _vm.order.contact.address.locality + ', ' : '')+" "+_vm._s(_vm.order.contact.address.country === 'UK' ? _vm.order.contact.address.townCity : _vm.order.contact.address.postalCode)+", "+_vm._s(_vm.order.contact.address.country === 'UK' ? _vm.order.contact.address.postalCode : _vm.order.contact.address.townCity))])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"d-inline-flex"},[_c('v-icon',{on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("clear")])],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"px-2",attrs:{"row":"","wrap":"","justify-space-between":""}},[_c('p',{staticClass:"px-2"},[_vm._v(_vm._s(_vm.$lang.labels.deliveryType)+":\n        "),_c('span',{style:(_vm.goDark ? 'color: white' : '')},[_c('strong',[_vm._v(_vm._s(_vm.$lang.actions[_vm.order.type]))])])]),_vm._v(" "),_c('p',{staticClass:"px-2"},[_vm._v(_vm._s(_vm.orderTimeLabel())+" "+_vm._s(_vm.$lang.labels.time)+":\n        "),_c('span',{style:(_vm.goDark ? 'color: white' : '')},[_vm._v("\n          "+_vm._s(_vm.formatDate(_vm.order.deliveryTime))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"px-2"},[_vm._v(_vm._s(_vm.$lang.header.rating)+": \n        "),_vm._l((5),function(star){return [_c('v-icon',{key:star,attrs:{"size":"19","color":_vm.order.ratingStars >= star ? 'primary' : ''}},[_vm._v("star\n          ")])]}),_vm._v(" "),(_vm.order.ratingComment)?_c('br'):_vm._e(),_vm._v(" "),(_vm.order.ratingComment)?_c('small',[_vm._v(_vm._s(_vm.$lang.labels.comment)+": ")]):_vm._e(),_vm._v(" "),(_vm.order.ratingComment)?_c('span',[_c('small',[_vm._v(_vm._s(_vm.order.ratingComment))])]):_vm._e()],2),_vm._v(" "),_c('p',{staticClass:"px-2"},[_vm._v(_vm._s(_vm.$lang.labels.total)+":\n        "),_c('span',{style:(_vm.goDark ? 'color: white' : '')},[(_vm.order.totalAmountWithoutDiscount !== null &&
              parseFloat(_vm.order.totalAmountWithoutDiscount) !== parseFloat(_vm.order.totalAmount))?_c('strike',[_vm._v("\n            ₤"+_vm._s(parseFloat(_vm.order.totalAmountWithoutDiscount).toFixed(2))+"\n          ")]):_vm._e(),_vm._v("\n          ₤"+_vm._s(parseFloat(_vm.order.totalAmount).toFixed(2))+"\n        ")],1)])]),_vm._v(" "),_c('v-layout',{staticClass:"px-3",attrs:{"row":"","wrap":"","justify-space-between":""}},[(_vm.items && _vm.items.length > 0)?_c('div',{staticClass:"v-table__overflow mb-4"},[_c('table',{staticClass:"v-datatable v-table"},[_c('thead',[_c('tr',{style:(_vm.goDark ? 'background-color: #303030' : '')},[_c('th',{staticClass:"column text-xs-left",attrs:{"role":"columnheader","scope":"col"}},[_vm._v(_vm._s(_vm.$lang.labels.quantity))]),_vm._v(" "),_c('th',{staticClass:"column text-xs-left",attrs:{"role":"columnheader","scope":"col"}},[_vm._v(_vm._s(_vm.$lang.labels.name))]),_vm._v(" "),_c('th',{staticClass:"column text-xs-right",attrs:{"role":"columnheader","scope":"col"}},[_vm._v(_vm._s(_vm.$lang.labels.details))]),_vm._v(" "),_c('th',{staticClass:"column text-xs-right",attrs:{"role":"columnheader","scope":"col"}},[_vm._v(_vm._s(_vm.$lang.labels.total))])]),_vm._v(" "),_c('tr',{staticClass:"v-datatable__progress"},[_c('th',{staticClass:"column",attrs:{"colspan":"100%"}})])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.items),function(item,index){return [_c('tr',{key:index,staticClass:"item",class:{'is-selected': item.selected},style:(_vm.goDark && (index %2 || item.selected) ? 'background-color: #303030' : '')},[_c('td',{staticClass:"text-xs-left",staticStyle:{"min-width":"130px"}},[_c('span',{staticClass:"quantity"},[_vm._v(_vm._s(item.quantity))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(item.name[_vm.$lang.current_lang] ? item.name[_vm.$lang.current_lang] : item.name.en))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.selectCartItem(index)}}},[_vm._v("info")])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('p',{staticClass:"price"},[_vm._v(_vm._s(_vm.company ? _vm.company.currencySymbol : '₤')+_vm._s(_vm.$store.state.calculatePrice(item.selectedSize, item.selectedVariants, item.selectedOptions, item.quantity, item.quantityOfIncludedOptions).toFixed(2)))])])]),_vm._v(" "),(item.selected)?_c('tr',{key:index + 10000},[_c('td',{attrs:{"colspan":"4"}},[_c('ul',{staticClass:"layout row wrap"},[(item.selectedSize.name)?_c('li',{staticClass:"flex py-2 xs4",attrs:{"xs6":""}},[_vm._v(_vm._s(_vm.$lang.labels.size)+": "+_vm._s(item.selectedSize.name[_vm.$lang.current_lang] ? item.selectedSize.name[_vm.$lang.current_lang] : item.selectedSize.name.en))]):_vm._e(),_vm._v(" "),(item.selectedStyle.name)?_c('li',{staticClass:"flex py-2 xs4",attrs:{"xs6":""}},[_vm._v(_vm._s(_vm.$lang.labels.style)+": "+_vm._s(item.selectedStyle.name[_vm.$lang.current_lang] ? item.selectedStyle.name[_vm.$lang.current_lang] : item.selectedStyle.name.en))]):_vm._e(),_vm._v(" "),(item.selectedVariants && item.selectedVariants.name)?_c('li',{staticClass:"flex py-2 xs4",attrs:{"xs6":""}},[_vm._v(_vm._s(_vm.$lang.labels.variant)+": "+_vm._s(item.selectedVariants.name[_vm.$lang.current_lang] ? item.selectedVariants.name[_vm.$lang.current_lang] : item.selectedVariants.name.en))]):_vm._e(),_vm._v(" "),(item.selectedOptions && item.selectedOptions.length > 0)?_c('li',{staticClass:"flex py-2 xs4",attrs:{"xs6":""}},[_vm._v("\n                  "+_vm._s(_vm.$lang.labels.options)+":\n                  "),_c('ul',{staticClass:"pl-4"},_vm._l((item.selectedOptions),function(option,index){return _c('li',{key:index},[_vm._v(_vm._s(option.name[_vm.$lang.current_lang] ? option.name[_vm.$lang.current_lang] : option.name.en)+" x "+_vm._s(option.quantity))])}),0)]):_vm._e(),_vm._v(" "),(item.comment)?_c('li',{staticClass:"flex py-2 xs12",attrs:{"md12":""}},[_vm._v(_vm._s(_vm.$lang.labels.comment)+": "+_vm._s(item.comment))]):_vm._e()])])]):_vm._e()]})],2)])]):_vm._e()]),_vm._v(" "),_c('v-layout',{staticClass:"px-2",attrs:{"row":"","wrap":"","justify-space-between":""}},[_c('p',{staticClass:"px-2"},[_vm._v(_vm._s(_vm.$lang.labels.createdOn)+":\n        "),_c('span',{style:(_vm.goDark ? 'color: white' : '')},[_vm._v("\n          "+_vm._s(_vm.formatDate(_vm.order.createdOn))+"\n        ")])])]),_vm._v(" "),_c('v-layout',{staticClass:"px-2 pb-2",attrs:{"row":"","wrap":"","justify-space-between":""}},[_c('div',{staticClass:"d-inline-flex"},[_c('p',{staticClass:"pl-2 pt-2"},[_vm._v("Blacklist:")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"error"},on:{"click":function($event){return _vm.blacklist('email')}}},[_vm._v(_vm._s(_vm.$lang.labels.email))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"error"},on:{"click":function($event){return _vm.blacklist('phone')}}},[_vm._v(_vm._s(_vm.$lang.labels.phone))]),_vm._v(" "),(_vm.loading)?_c('v-progress-circular',{staticClass:"mt-2",attrs:{"indeterminate":""}}):_vm._e()],1),_vm._v(" "),_c('v-btn',{on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v(_vm._s(_vm.$lang.actions.close))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 49:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderDetails_vue__ = __webpack_require__(450);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db2b2e20_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderDetails_vue__ = __webpack_require__(453);
function injectStyle (ssrContext) {
  __webpack_require__(451)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-db2b2e20"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db2b2e20_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/0.5c8ef4988c88d0ea2843.js